import React from 'react'
import { useForm, Link } from '@inertiajs/react'
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
} from '@mui/material'
import ManagementLayout from '@/components/layouts/ManagementLayout'
import type { Account } from '@/types'

interface Props {
  account: Account
}

export default function AccountsEdit({ account }: Props) {
  const { data, setData, patch, processing, errors } = useForm({
    name: account.name || '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/accounts/${account.slug}`)
  }

  return (
    <ManagementLayout>
      <Box sx={{ maxWidth: 672, mx: 'auto' }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" fontWeight={600}>
            Edit Account
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Update your account settings.
          </Typography>
        </Box>

        <Paper sx={{ p: 3 }}>
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="Name"
              fullWidth
              value={data.name}
              onChange={(e) => setData('name', e.target.value)}
              error={!!errors.name}
              helperText={errors.name || 'The name of your account or organization.'}
              placeholder="My Organization"
              autoFocus
            />

            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button component={Link} href={`/accounts/${account.slug}/dashboard`}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={processing}>
                Update Account
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </ManagementLayout>
  )
}
